import { message } from "antd";

export default function ChapaPaymentSuccess() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-green-400 to-blue-500 text-white p-6">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        <h1 className="text-2xl font-bold text-gray-800">
          Payment Successful!
        </h1>
        <p className="mt-4 text-gray-600">
          You have successfully made a withdraw.
        </p>

        <div className="mt-8">
          <svg
            className="w-16 h-16 text-green-500 mx-auto"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M10 18a7 7 0 100-14 7 7 0 000 14zM10 1a9 9 0 100 18 9 9 0 000-18zm-2 11a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </div>

        <div className="mt-6">
          <button
            onClick={() => {
              if ((window as any)?.emun_channel?.postMessage) {
                (window as any).emun_channel.postMessage({
                  type: "chapa_payment",
                  status: "success",
                });
              } else message.warning("Unable to post message");
            }}
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-8 rounded transition duration-300"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
